import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { trendsMobileService } from "../../../../../../../services/mobileAPI/trends.endpoints";
import { setDisplayErrorSnackBar } from "../../../../../../../features/userSlice";

export const useTrendsMobileOverride = ({
  params,
  setDataAction,
  setLoadingAction,
}: any) => {
  const dispatch = useDispatch();
  const fetchOverride = useCallback(
    async (overrideParams: any) => {
      try {
        if (setLoadingAction) {
          dispatch(setLoadingAction(true));
        }
        const response = await trendsMobileService.getTrendsData(
          overrideParams || params,
        );
        if (!response?.status || response.status !== 200) {
          throw new Error("API failed");
        }
        dispatch(setDataAction(response.data?.data || []));
      } catch (e: any) {
        dispatch(
          setDisplayErrorSnackBar({
            message: e?.parsedText || "Failed to fetch override data",
            type: "error",
          }),
        );
      } finally {
        if (setLoadingAction) {
          dispatch(setLoadingAction(false));
        }
      }
    },
    // eslint-disable-next-line
    [params, setDataAction],
  );
  return { fetchOverride };
};
